import { useEffect } from 'react';
import { useExit } from '@wix/cli-ui-kit';
import { useSiteConfig } from '../../../model.js';
import { useDevEnvironment } from '../DevEnvironment.js';
import { useUpdateDeploymentTopologyForSite } from '../../../hooks/useUpdateDeploymentTopology.js';

export function useSiteDeploymentTopologyUpdater() {
  const { baseUrl, versionOverrideId } = useDevEnvironment();
  const { siteId } = useSiteConfig();
  const updateTopology = useUpdateDeploymentTopologyForSite(siteId);
  const exit = useExit();

  useEffect(() => {
    updateTopology({
      versionOverrideId,
      siteUrl: baseUrl,
      environment: 'development',
    }).catch(exit);
  }, [versionOverrideId, baseUrl, updateTopology, exit]);
}
